import { Grid as GridParent } from "./Grid";
import { GridItem } from "./GridItem";

export { type GridProps } from "./Grid";
export { type GridItemProps } from "./GridItem";

// Below is to fix bug [ANV-1252](https://github.com/servicetitan/hammer/pull/394)
export type { LayoutUtilProps } from "../../types";

export const Grid = Object.assign(GridParent, {
  Item: GridItem,
});
